// Транспорт ленты предупреждений точки (T-047). Без React и без состояния.

import { httpClient } from '@/shared/api';
import type { components } from '@/shared/api/generated/schema';

type Schemas = components['schemas'];

export type FeedMessage = Schemas['AlertMessage'];
export type FeedPage = Schemas['AlertFeed'];
export type LocationFeedSettings = Schemas['LocationAlertSettings'];

const FEED = '/printing/alerts/';
const SETTINGS = '/printing/alerts/settings/';

/**
 * Ответ — действительно порция ленты. Прокси, портал Wi-Fi или сервер не той версии
 * отвечают кодом 200 с чужим телом; колокольчик на каждом экране не должен падать
 * на `undefined.results`, а пустое тело читается пустой лентой.
 */
function asFeedPage(value: unknown): FeedPage {
  const body = (value ?? {}) as Partial<FeedPage>;
  return {
    results: Array.isArray(body.results) ? body.results : [],
    has_more: body.has_more === true,
    server_time: typeof body.server_time === 'string' ? body.server_time : new Date().toISOString(),
    retention_days: typeof body.retention_days === 'number' ? body.retention_days : 14,
  };
}

export const alertFeedApi = {
  async page(
    location: string,
    cursor: { readonly since?: string; readonly before?: string } = {},
  ): Promise<FeedPage> {
    return asFeedPage(
      await httpClient.get<unknown>(FEED, {
        searchParams: { location, since: cursor.since, before: cursor.before },
      }),
    );
  },

  settings: (location: string) =>
    httpClient.get<LocationFeedSettings>(SETTINGS, { searchParams: { location } }),

  setFeedTiers: (location: string, tiers: readonly string[]) =>
    httpClient.patch<LocationFeedSettings>(
      SETTINGS,
      { feed_tiers: tiers },
      { searchParams: { location } },
    ),
};
